import $ from 'jquery';

// XMLHttpRequest readyState value for "DONE"
const XHR_READY_STATE_DONE = 4; // Same as XMLHttpRequest.DONE

export default class RequestManager {
    _pendingRequests = {};
    _requestIds = {};

    start(endpointKey, url, payload, onDone, options = {}) {
        const previous = this._pendingRequests[endpointKey];
        if (previous && previous.readyState !== XHR_READY_STATE_DONE) {
            try { previous.abort(); } catch { /* ignore */ }
        }

        const requestId = (this._requestIds[endpointKey] || 0) + 1;
        this._requestIds[endpointKey] = requestId;

        const method = (options.type || options.method || 'POST').toUpperCase();
        const ajaxOptions = {
            url,
            type: method,
            contentType: method === 'POST' ? 'application/json' : options.contentType,
            data: method === 'POST' ? JSON.stringify(payload) : (options.data !== undefined ? options.data : payload),
            ...options
        };

        const jqXHR = $.ajax(ajaxOptions).done(data => {
            if (this._requestIds[endpointKey] !== requestId) return;
            onDone(data);
        }).always(() => {
            if (this._requestIds[endpointKey] === requestId) {
                this._pendingRequests[endpointKey] = null;
            }
        });

        this._pendingRequests[endpointKey] = jqXHR;
        return jqXHR;
    }

    abort(endpointKey) {
        const req = this._pendingRequests[endpointKey];
        if (req && req.readyState !== XHR_READY_STATE_DONE) {
            try { req.abort(); } catch { /* ignore */ }
        }
        this._pendingRequests[endpointKey] = null;
    }

    abortAll() {
        Object.keys(this._pendingRequests).forEach(k => this.abort(k));
    }
} 